module.exports = __webpack_public_path__ + "media/tinkering.37b8dcb0.ogg";